export class ProgressAllocationSnapshotRequest {
    ServiceYear: number;
    StartDate: string;
    EndDate: string;
    Interval: number;
    IDs: string[];
}
